<template>
  <el-form
    id="process-form"
    ref="form"
    :rules="rules"
    :model="ruleForm"
    label-width="95px"
    size="mini"
  >
    <el-form-item label="调度" prop="scheduled">
      <el-switch v-model="ruleForm.scheduled" @change="scheduChange" />
    </el-form-item>
    <el-form-item label="Minute" prop="minute">
      <el-popover
        placement="top-start"
        width="270"
        trigger="hover"
        :open-delay="2000"
      >
        <div class="ins">
          <div
            class="ins-tr"
            v-for="(ins, k) in instructions['minute']"
            :key="k"
          >
            <div class="ins-td">{{ ins[0] }}</div>
            <div class="ins-td">{{ ins[1] }}</div>
          </div>
        </div>
        <el-input
          :disabled="disabled"
          slot="reference"
          v-model="ruleForm.minute"
        ></el-input>
      </el-popover>
    </el-form-item>
    <el-form-item label="Hour" prop="hour">
      <el-popover
        placement="top-start"
        width="270"
        trigger="hover"
        :open-delay="2000"
      >
        <div class="ins">
          <div class="ins-tr" v-for="(ins, k) in instructions['hour']" :key="k">
            <div class="ins-td">{{ ins[0] }}</div>
            <div class="ins-td">{{ ins[1] }}</div>
          </div>
        </div>
        <el-input
          :disabled="disabled"
          slot="reference"
          v-model="ruleForm.hour"
        ></el-input>
      </el-popover>
    </el-form-item>
    <el-form-item label="Day" prop="day">
      <el-popover
        placement="top-start"
        width="270"
        trigger="hover"
        :open-delay="2000"
      >
        <div class="ins">
          <div class="ins-tr" v-for="(ins, k) in instructions['day']" :key="k">
            <div class="ins-td">{{ ins[0] }}</div>
            <div class="ins-td">{{ ins[1] }}</div>
          </div>
        </div>
        <el-input
          :disabled="disabled"
          slot="reference"
          v-model="ruleForm.day"
        ></el-input>
      </el-popover>
    </el-form-item>
    <el-form-item label="Month" prop="month">
      <el-popover
        placement="top-start"
        width="270"
        trigger="hover"
        :open-delay="2000"
      >
        <div class="ins">
          <div
            class="ins-tr"
            v-for="(ins, k) in instructions['month']"
            :key="k"
          >
            <div class="ins-td">{{ ins[0] }}</div>
            <div class="ins-td">{{ ins[1] }}</div>
          </div>
        </div>
        <el-input
          :disabled="disabled"
          slot="reference"
          v-model="ruleForm.month"
        ></el-input>
      </el-popover>
    </el-form-item>
    <el-form-item label="Week" prop="week">
      <el-popover
        placement="top-start"
        width="270"
        trigger="hover"
        :open-delay="2000"
      >
        <div class="ins">
          <div class="ins-tr" v-for="(ins, k) in instructions['week']" :key="k">
            <div class="ins-td">{{ ins[0] }}</div>
            <div class="ins-td">{{ ins[1] }}</div>
          </div>
        </div>
        <el-input
          :disabled="disabled"
          slot="reference"
          v-model="ruleForm.week"
        ></el-input>
      </el-popover>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "process-form",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    process: {
      type: Object
    },
    taskType: {
      type: String
    }
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if (this.ruleForm.scheduled && !value) {
        callback(new Error("请输入调度策略"));
      }
      callback();
    };
    const validateMinute = (rule, value, callback) => {
      let reg = /^[*]{1}$|^[0-5]?\d(\/[0-5]?\d)?(-[0-5]?\d(\/[0-5]?\d)?)?(,[0-5]?\d(\/[0-5]?\d)?(-[0-5]?\d(\/[0-5]?\d)?)?)*$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("时间填写错误！"));
      }
    };
    const validateHour = (rule, value, callback) => {
      let reg = /^[*]{1}$|^(\d|1\d|2[0-3])(\/(\d|1\d|2[0-3]))?(-(\d|1\d|2[0-3])(\/(\d|1\d|2[0-3]))?)?(,(\d|1\d|2[0-4])(\/(\d|1\d|2[0-3]))?(-(\d|1\d|2[0-3])(\/(\d|1\d|2[0-3]))?)?)*$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("时间填写错误！"));
      }
    };
    const validateDay = (rule, value, callback) => {
      let reg = /^[*]{1}$|^[?]{1}$|^(\d|[1-2]\d|3[0-1])(\/(\d|[1-2]\d|3[0-1]))?(-(\d|[1-2]\d|3[0-1])(\/(\d|[1-2]\d|3[0-1]))?)?(,(\d|[1-2]\d|3[0-1])(\/(\d|[1-2]\d|3[0-1]))?(-(\d|[1-2]\d|3[0-1])(\/(\d|[1-2]\d|3[0-1]))?)?)*$/;
      if (reg.test(value)) {
        if (this.ruleForm.week === "") {
          callback();
        } else if (this.ruleForm.week === "?") {
          if (value !== "?") {
            callback();
          }
          callback(new Error("Day与Week必须并且只能设置一个"));
        } else {
          if (value === "?") {
            callback();
          }
          callback(new Error("Day与Week必须并且只能设置一个"));
        }
      } else {
        callback(new Error("时间填写错误！"));
      }
    };
    const validateMonth = (rule, value, callback) => {
      let reg = /^[*]{1}$|^(\d|1[0-2])(\/(\d|1[0-2]))?(-(\d|1[0-2])(\/(\d|1[0-2]))?)?(,(\d|1[0-2])(\/(\d|1[0-2]))?(-(\d|1[0-2])(\/(\d|1[0-2]))?)?)*$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("时间填写错误！"));
      }
    };
    const validateWeek = (rule, value, callback) => {
      let reg = /^[*]{1}$|^[?]{1}$|^[1-7](\/[1-7])?(-[1-7](\/[1-7])?)?(,[1-7](\/[1-7])?(-[1-7](\/[1-7])?)?)*$/;
      if (reg.test(value)) {
        if (this.ruleForm.day === "") {
          callback();
        } else if (this.ruleForm.day === "?") {
          if (value !== "?") {
            callback();
          }
          callback(new Error("Day与Week必须并且只能设置一个"));
        } else {
          if (value === "?") {
            callback();
          }
          callback(new Error("Day与Week必须并且只能设置一个"));
        }
      } else {
        callback(new Error("时间填写错误！"));
      }
    };
    return {
      timeShow: false,
      ruleForm: {
        scheduled: false,
        minute: "",
        hour: "",
        day: "",
        month: "",
        week: ""
      },
      rules: {
        minute: [
          {
            validateTime,
            trigger: "blur"
          },
          {
            validator: validateMinute,
            trigger: "change"
          },
          {
            validator: validateMinute,
            trigger: "blur"
          }
        ],
        hour: [
          {
            validateTime,
            trigger: "blur"
          },
          {
            validator: validateHour,
            trigger: "change"
          },
          {
            validator: validateHour,
            trigger: "blur"
          }
        ],
        day: [
          {
            validateTime,
            trigger: "blur"
          },
          {
            validator: validateDay,
            trigger: "change"
          },
          {
            validator: validateDay,
            trigger: "blur"
          }
        ],
        month: [
          {
            validateTime,
            trigger: "blur"
          },
          {
            validator: validateMonth,
            trigger: "change"
          },
          {
            validator: validateMonth,
            trigger: "blur"
          }
        ],
        week: [
          {
            validateTime,
            trigger: "blur"
          },
          {
            validator: validateWeek,
            trigger: "change"
          },
          {
            validator: validateWeek,
            trigger: "blur"
          }
        ]
      },
      instructions: {
        minute: [
          ["*", "any value"],
          [",", "value list separators"],
          ["-", "range of values"],
          ["/", "step values"],
          ["0-59", "allowed values"]
        ],
        hour: [
          ["*", "any value"],
          [",", "value list separators"],
          ["-", "range of values"],
          ["/", "step values"],
          ["0-23", "allowed values"]
        ],
        day: [
          ["*", "any value"],
          [",", "value list separators"],
          ["-", "range of values"],
          ["/", "step values"],
          ["1-31", "allowed values"],
          ["?", "blank"]
        ],
        month: [
          ["*", "any value"],
          [",", "value list separators"],
          ["-", "range of values"],
          ["/", "step values"],
          ["1-12", "allowed values"]
        ],
        week: [
          ["*", "any value"],
          [",", "value list separators"],
          ["-", "range of values"],
          ["/", "step values"],
          ["1-7", "SUN MON TUE WED THU FRI SAT"],
          ["?", "blank"]
        ]
      }
    };
  },
  watch: {
    process: {
      immediate: true,
      handler(v) {
        if (v) {
          this.ruleForm = JSON.parse(JSON.stringify(v));
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        }
      }
    }
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        if (this.ruleForm.scheduled) {
          this.$refs.form.validate(valid => {
            if (valid) {
              resolve(this.ruleForm);
            } else {
              this.$message({
                type: "error",
                message: "执行计划参数填写有错误"
              });
              reject("four");
            }
          });
        } else {
          resolve(this.ruleForm);
        }
      });
    },
    scheduChange(v) {
      if (this.taskType === "watch") {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$emit("scheduChange", v);
          } else {
            this.$message({
              type: "error",
              message: "请设置调度策略"
            });
            this.ruleForm.scheduled = !v;
          }
          this.$refs.form.clearValidate();
        });
      }

      if (!v) {
        this.$refs.form.clearValidate();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#process-form {
  padding: 15px 10px;
}
.ins {
  display: flex;
  flex-direction: column;
  .ins-tr {
    min-height: 36px;
    display: flex;
    .ins-td:first-child {
      flex: 0 0 20%;
    }
    .ins-td:last-child {
      flex: 1 1 auto;
    }
  }
}
</style>
